/* eslint jsx-a11y/href-no-hash: "off" */

import React from "react";
import Skins from "../_data/Skins.js";
import {launchEditModal} from "../b5-crew-management/edit-combatant-operations.js";
import RemoveBotButton from './RemoveBotButton';
import {setMatchmakingValue} from '../redux-actions/battle-actions'
import {getClassIcon} from './get-class-icon'

class CrewMember extends React.Component {
  handleClick() {
    //Do not allow editing after Ready
    if (this.props.isEditable && !this.props.isReady) {
      launchEditModal(this.props.memberId);
    }
  }

  //Only for "Rally Inviter" version of this component
  handleOpenInviteModal() {
    setMatchmakingValue({
      isLobbyInviteModalOpen: true
    })
  }

  handleEditClick(e) {
    e.preventDefault();

    //Do not allow editing after Ready
    if (this.props.isReady) {
      return false;
    }

    launchEditModal(this.props.memberId);
  }

  getLeftPosition() {
    const {position} = this.props;
    //TODO: If need later, add support for 2 or 1 person teams.

    //TODO: 4,5,6 are only for Rally Lobby positioning. Has nothing to do with actual arenaPosition

    if (position === 2 || position === 4) {
      //left
      return "20%";
    }
    if (position === 1 || position === 5) {
      //main (center)
      return "50%";
    }
    if (position === 3 || position === 6) {
      //right
      return "80%";
    }
  }

  getTopPosition() {
    const {position, isEvenPositionMode, evenPositionRowNumber} = this.props;
    //Option to have no bumping
    if (isEvenPositionMode) {
      //Top row (first 3 people)
      if (evenPositionRowNumber === 1) {
        return 0;
      }
      //Top row (first 3 people)
      if (evenPositionRowNumber === 2) {
        return "20em";
      }
    }

    if (position === 1) {
      //main (center)
      return "-2.3em";
    }
    return 0;
  }

  renderEditLink() {
    if (this.props.isEditable && !this.props.isReady) {
      const containerStyle = {
        textAlign: "center",
        paddingTop: "0.3em"
      };
      return (
        <div style={containerStyle}>
          <a
            href="#"
            className="button extra-small"
            onClick={this.handleEditClick.bind(this)}
          >
            <span className="button--text">...</span>
          </a>
        </div>
      );
    }
    return null;
  }

  renderReadyBlip() {
    if (this.props.isReady) {
      const containerStyle = {
        textAlign: "center",
        paddingTop: "1em",
      };

      return (
        <div style={containerStyle}>
          <span
            href="#"
            className="button extra-small ready-pressed"
          >
            <span className="button--text">Ready</span>
          </span>
        </div>
      )
    }

    return null
  }

  renderBotRemoveLink() {
    if (this.props.canShowBotRemoveButton && this.props.isBot) {
      const containerStyle = {
        textAlign: "center",
        paddingTop: "1em"
      };
      return (
        <div style={containerStyle}>
          <RemoveBotButton combatantId={this.props.combatantId} />
        </div>
      );
    }
    return null;
  }


  renderClassName() {
    if (this.props.showClass) {
      const style = {
        fontSize: "0.8em",
        color: "#585B72"
      };
      return (
        <div style={style}>
          {this.props.isBot ? "BOT" : this.props.loadoutTitle}
        </div>
      )
    }

    return null
  }

  renderClassBadge() {
    if (this.props.showClass) {

      const style = {
        marginTop: "1em"
      };
      return (
        <div style={style}>
          {getClassIcon(this.props.rpgClass, "3em")}
        </div>
      )
    }
    return null
  }


  renderRallyInvite() {
    if (this.props.isRallyInviter) {
      const containerStyle = {
        textAlign: "center",
        paddingTop: "1em"
      };
      return (
        <div style={containerStyle}>
          <a
            href="#"
            className="button extra-small invite-theme"
            onClick={this.handleOpenInviteModal.bind(this)}
          >
            <span className="button--text">INVITE</span>
          </a>
        </div>
      );
    }
    return null;
  }

  render() {
    const skin = Skins()[this.props.skinId];

    const containerStyle = {
      position: "absolute",
      width: "30%",
      transform: "translateX(-50%)",
      left: this.getLeftPosition(),
      top: this.getTopPosition()
    };

    const characterContainerStyle = {
      display: "block",
      width: "11em",
      height: "11em",
      position: "relative",
      margin: "0 auto"
    };
    const characterStyle = {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      display: "block",

      //If Rally inviter, use padding to shrink the skin down
      padding: this.props.isRallyInviter ? "2em" : "0"
    };

    const infoStyle = {
      container: {
        marginBottom: "1em",
        textAlign: "center"
      },
      nameStyle: {
        color: this.props.isEditable ? "#4C86CA" : "inherit",
        textAlign: "center",
        textTransform: "uppercase",
        marginBottom: "0.5em"
      }
    };

    const laptopStyle = {
      position: "absolute",
      left: "2.8em",
      top: "5.1em",
      width: "5.3em",
      display: "block"
    };

    const hoverClass = this.props.isEditable ? "pointer-on-hover" : "";
    return (
      <div
        style={containerStyle}
        className={hoverClass}
        onClick={this.handleClick.bind(this)}
      >
        <div style={infoStyle.container}>
          <div style={infoStyle.nameStyle}>
            {this.props.name}
          </div>
          { this.renderClassName() }
          { this.renderClassBadge() }

        </div>
        <div style={characterContainerStyle}>
          <img
            style={characterStyle}
            src="/images/misc/shadow.svg"
            alt="Shadow"
          />
          <img
            style={characterStyle}
            src={skin.frontViewSrc}
            alt={this.props.name}
          />
          {
            this.props.showLaptop ?
              <img
                style={laptopStyle}
                src="/images/misc/laptop-back.svg"
                alt={"Laptop"}
              /> : null
          }
        </div>
        {this.renderEditLink()}
        {this.renderBotRemoveLink()}
        {this.renderReadyBlip()}
        {this.renderRallyInvite()}
      </div>
    );
  }
}

export default CrewMember;



// WEBPACK FOOTER //
// ./src/b5-home/CrewMember.js